import AddIcon from '@mui/icons-material/Add'
import AddCircleIcon from '@mui/icons-material/AddCircle'
import DeleteIcon from '@mui/icons-material/Delete'
import EventNoteIcon from '@mui/icons-material/EventNote'
import SettingsIcon from '@mui/icons-material/Settings'
import StarRoundedIcon from '@mui/icons-material/StarRounded'
import { Menu, MenuItem } from '@mui/material'
import Checkbox from '@mui/material/Checkbox'
import isEqual from 'lodash/isEqual'
import moment from 'moment'
import { useContext, useEffect, useState } from 'react'
import { getTimezoneOffset } from 'src/consumer/helpers/utilFunctions'
import Calendar from 'react-calendar'
import { toast } from 'react-toastify'
import { NEW_MENTOR_SCHEDULE, RENDERING_ORDER_OF_DAYS } from 'src/consumer/constants'
import { useScreenSize } from 'src/customHooks/customHooks'
import { MentorProfileContext } from 'src/mentor/context/MentorProfileContext'
import {
  getDefaultScheduleFromSchedules,
  getEventsArrayFromEventIdsArray,
  getEventsNotInAnySchedule,
} from 'src/mentor/helpers/utilityFunctions'
import { GenericDisplayFlex, GenericDisplayFlexColumn } from 'src/mentor/layout/Styles'
import { postMPData } from 'src/mentor/services'
import { StyledSelectTZCO } from '../MentorCalendarPage/MentorCalendarPageStyles'
import MultipleSelectCheckmarks from './Components'
import {
  AvailabilityPageContainer,
  DateOverrideCalAndTimeParent,
  EventAndTimeZoneContainer,
  GenericMentorPortalModalComponent,
  NewSchedulePageComponent,
  OverrideCalendarContainer,
  PageContentOneContainer,
  PageDescriptionText,
  PageHeadlineComponent,
  PageMainContentContainer,
  PageMainContentPartFour,
  PageMainContentPartOne,
  PageMainContentPartThree,
  PageMainContentPartTwo,
  ScheduleButton,
  ScheduleEventsClearButton,
  ScheduleName,
  ScheduleSelectHeading,
  ScheduleSelectHorizonalContainer,
  UnderlineActiveButtons,
  WeekItemContainer,
  getSlotTimeOptions,
  getTimeZoneOptionsWithValueAsTimezoneOffset,
  getUniqueIdFromTitle,
} from './MentorAvailabilityPageStyles'
import './OverrideBookingCalendar.css'

export default function MentorAvailabilityPage() {
  const { mentorProfileData, updateProfileData, mentorClinicAssociationData } =
    useContext(MentorProfileContext)
  const [schedule, setSchedule] = useState(null)
  const [selectedWorkingScheduleIndex, setSelectedWorkingScheduleIndex] = useState(0)
  const [selectedEditMode, setSelectedEditMode] = useState('regular') // other is date override
  const [newScheduleModalOpen, setNewScheduleModalOpen] = useState(false)
  const { width } = useScreenSize()

  const [selectedOverrideDateValue, setSelectedOverrideDateValue] = useState()

  const [anchorForSettings, setAnchorForSettings] = useState(null)

  const [warningLocation, setWarningLocation] = useState({})
  const [clinicAssociationTimingWarningLocation, setClinicAssociationTimingWarningLocation] =
    useState({})

  const renderingOrderDays = [
    'sunday',
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
  ]

  async function updateSchedule() {
    const response = await postMPData('/api/secure/teacher/update/schedule', schedule)
    if (response?.status === 200) {
      toast.success('Updated successfully')
      // console.log("Updated your schedule")
    }
  }

  async function updateScheduleAndGetProfile() {
    await updateSchedule()
    await updateProfileData()
    // setSelectedWorkingScheduleIndex(0)           // i don't know why it was here. commenting it so changes in any schedule don't bring me back to schedule zero
  }

  useEffect(() => {
    let updatedSchedules
    if (mentorProfileData && mentorProfileData?.schedules) {
      updatedSchedules = JSON.parse(JSON.stringify(mentorProfileData?.schedules))
    }
    // let updatedSchedules = mentorProfileData?.schedules;
    if (!Array?.isArray(updatedSchedules)) {
      updatedSchedules = []
    }
    setSchedule(updatedSchedules)
  }, [mentorProfileData])

  useEffect(() => {
    if (
      Boolean(schedule) &&
      schedule?.length !== 0 &&
      !isEqual(mentorProfileData?.schedules, schedule)
    ) {
      if (Object.values(warningLocation)?.every((value) => value === undefined)) {
        if (
          Array.isArray(mentorClinicAssociationData) &&
          mentorClinicAssociationData?.length > 0 &&
          schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0] &&
          scheduleOfSelectedClinic
        ) {
          setClinicAssociationTimingWarningLocation(
            giveErrorIfOutsideClinicHours(
              schedule,
              selectedWorkingScheduleIndex,
              scheduleOfSelectedClinic,
              clinicAssociationTimingWarningLocation,
            ),
          )
          if (
            Object.values(
              giveErrorIfOutsideClinicHours(
                schedule,
                selectedWorkingScheduleIndex,
                scheduleOfSelectedClinic,
                clinicAssociationTimingWarningLocation,
              ),
            )?.every((value) => value === undefined)
          ) {
            updateScheduleAndGetProfile()
          }
        } else {
          updateScheduleAndGetProfile()
        }
      }
    }
  }, [schedule])

  // for events
  const handleMutliSelectEventsChange = (event) => {
    setSchedule((prevSchedule) => {
      const updatedSchedule = prevSchedule?.map((item, index) => {
        if (index === selectedWorkingScheduleIndex) {
          return { ...item, eventIds: event.target.value }
        }
        return item
      })
      return updatedSchedule
    })
  }

  // for clearing schedule events
  const handleMutliSelectClear = () => {
    setSchedule((prevSchedule) => {
      const updatedSchedule = prevSchedule?.map((item, index) => {
        if (index === selectedWorkingScheduleIndex) {
          return { ...item, eventIds: [] }
        }
        return item
      })
      return updatedSchedule
    })
  }

  // for timezone
  const handleTimeZoneChange = (event) => {
    const selectedTimeZone = event.target.value
    setSchedule((prevSchedule) => {
      const updatedSchedule = prevSchedule?.map((item, index) => {
        if (index === selectedWorkingScheduleIndex) {
          return { ...item, timeZone: selectedTimeZone }
        }
        return item
      })
      return updatedSchedule
    })
  }

  // for clinic association
  const handleClinicAssociationChange = (event) => {
    setClinicAssociationTimingWarningLocation({
      sunday: undefined,
      monday: undefined,
      tuesday: undefined,
      wednesday: undefined,
      thursday: undefined,
      friday: undefined,
      saturday: undefined,
    })
    const selectedClinicId = event.target.value
    setSchedule((prevSchedule) => {
      const updatedSchedule = prevSchedule?.map((item, index) => {
        if (index === selectedWorkingScheduleIndex) {
          const desiredSchedule = getDefaultScheduleFromSchedules(
            mentorClinicAssociationData?.find((clinic) => clinic?.id === selectedClinicId)
              ?.schedules,
          )
          if (desiredSchedule?.timeZone && desiredSchedule?.weeklyHourMap) {
            return {
              ...item,
              timeZone: desiredSchedule?.timeZone,
              weeklyHourMap: desiredSchedule?.weeklyHourMap,
              scopeSchedules: [selectedClinicId],
            }
          } else {
            return { ...NEW_MENTOR_SCHEDULE, timeZone: encodeURIComponent(getTimezoneOffset()) }
          }
        }
        return item
      })
      return updatedSchedule
    })
  }

  // for checkbox on slots
  const handleCheckboxChange = (event, dayOfWeek) => {
    const { checked } = event.target
    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      updatedSchedule[selectedWorkingScheduleIndex].weeklyHourMap[dayOfWeek].available = checked
      if (checked) {
        updatedSchedule[selectedWorkingScheduleIndex].weeklyHourMap[dayOfWeek].slotList = [
          { startTime: '09:00:00', endTime: '17:00:00' },
        ]
      } else {
        updatedSchedule[selectedWorkingScheduleIndex].weeklyHourMap[dayOfWeek].slotList = []
      }
      return updatedSchedule
    })
  }

  // for slot delete button
  const handleSlotDelete = (dayOfWeek, indexOfSlot) => {
    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      updatedSchedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayOfWeek]?.slotList?.splice(
        indexOfSlot,
        1,
      )
      if (
        updatedSchedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayOfWeek]?.slotList
          ?.length === 0
      ) {
        updatedSchedule[selectedWorkingScheduleIndex].weeklyHourMap[dayOfWeek].available = false
      }
      return updatedSchedule
    })
  }

  // for slot add button
  const handleSlotAddition = (dayName) => {
    setSchedule((prev) => {
      const scheduleArrayAfterAddition = [...prev]
      const slotList =
        scheduleArrayAfterAddition?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]
          ?.slotList
      if (!Boolean(slotList) || slotList?.length === 0) {
        scheduleArrayAfterAddition[selectedWorkingScheduleIndex].weeklyHourMap[dayName].slotList = [
          { startTime: '09:00:00', endTime: '17:00:00' },
        ]
      } else {
        const lastTimeSlot = slotList?.slice(-1)
        const prevEndTime = lastTimeSlot?.[0]?.endTime
        scheduleArrayAfterAddition?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[
          dayName
        ]?.slotList?.push({
          startTime: moment(prevEndTime, 'HH:mm:ss')?.add(1, 'hour')?.format('HH:mm:ss'),
          endTime: moment(prevEndTime, 'HH:mm:ss')?.add(2, 'hour')?.format('HH:mm:ss'),
        })
      }

      return scheduleArrayAfterAddition
    })
  }

  // for slot time change
  const handleChangeSlotTime = (dayName, slotIndex, timeType, timeValue) => {
    if (timeType === 'startTime') {
      if (
        timeValue >=
        schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]?.slotList?.[slotIndex]
          ?.endTime
      ) {
        setWarningLocation((prev) => ({
          ...prev,
          [`${dayName}-${slotIndex}`]:
            'Ensure start time is less than end time and there is no overlapping slot',
        }))
      } else {
        setWarningLocation((prev) => ({
          ...prev,
          [`${dayName}-${slotIndex}`]: undefined,
        }))
      }
    } else if (timeType === 'endTime') {
      if (
        timeValue <=
        schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]?.slotList?.[slotIndex]
          ?.startTime
      ) {
        setWarningLocation((prev) => ({
          ...prev,
          [`${dayName}-${slotIndex}`]:
            'Ensure start time is less than end time and there is no overlapping slot',
        }))
      } else {
        setWarningLocation((prev) => ({
          ...prev,
          [`${dayName}-${slotIndex}`]: undefined,
        }))
      }
    }

    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      updatedSchedule[selectedWorkingScheduleIndex].weeklyHourMap[dayName].slotList[slotIndex][
        timeType
      ] = timeValue
      return updatedSchedule
    })
  }

  // for creating schedule
  const handleScheduleCreation = (data) => {
    const filteredEventTypes = getEventsNotInAnySchedule(mentorProfileData)

    const newScheduleData = {}
    newScheduleData.defaultSchedule = mentorProfileData?.schedules?.some(
      (schedule) => schedule?.defaultSchedule,
    )
      ? false
      : true
    newScheduleData.eventIds = filteredEventTypes?.length > 0 ? [filteredEventTypes?.[0]?.uid] : []
    newScheduleData.exemptDates = []
    newScheduleData.id = getUniqueIdFromTitle(data?.title)
    newScheduleData.title = data?.title
    newScheduleData.weeklyHourMap = data?.weeklyHourMap
    newScheduleData.timeZone = data?.timeZone

    setSchedule((prev) => [...prev, newScheduleData])
    setNewScheduleModalOpen(false)
  }

  // for deleting schedule
  const handleDeleteSchedule = () => {
    setSchedule((prev) => {
      const schedulesArrayAfterDeletion = [...prev]
      schedulesArrayAfterDeletion?.splice(selectedWorkingScheduleIndex, 1)
      return schedulesArrayAfterDeletion
      //bug here, it won't delete if only one schedule is there
    })
  }

  // for making a schedule default
  const handleMakeDefaultSchedule = () => {
    setSchedule((prev) => {
      let schedulesArrayAfterChangingDefault = [...prev]
      schedulesArrayAfterChangingDefault?.forEach((tempScheduleItem, tempScheduleItemIndex) => {
        tempScheduleItem.defaultSchedule = false
      })
      schedulesArrayAfterChangingDefault[selectedWorkingScheduleIndex].defaultSchedule = true
      return schedulesArrayAfterChangingDefault
    })
  }

  // for settings button click
  const settingsOpen = Boolean(anchorForSettings)
  const handleClickOnSettings = (event) => {
    setAnchorForSettings(event.currentTarget)
  }
  const handleCloseOfSettings = () => {
    setAnchorForSettings(null)
  }

  // ----------------------- override calendar related functions :
  const onChangeOverrideDate = (nextValue) => {
    setSelectedOverrideDateValue(nextValue)
  }

  const dateToday = new Date()
  const maxDate = new Date(dateToday)
  maxDate?.setMonth(dateToday?.getMonth() + 3) // setting max date of calendar

  const handleOverrideMonthChange = async (action, activeStartDate, value, view) => {
    if (
      (action === 'prev' && view === 'month') ||
      (action === 'prev2' && view === 'month') ||
      (action === 'next' && view === 'month') ||
      (action === 'next2' && view === 'month') ||
      (action === 'drillDown' && view === 'month')
    ) {
      setSelectedOverrideDateValue(null)
    }
  } // function to handle when month is changed, getting all available time slots

  // for override day slot add button
  const handleOverrideDateSlotAddition = (dateString) => {
    setSchedule((prev) => {
      const dateOverrideArrayAfterAddition = [...prev]
      const slotList = dateOverrideArrayAfterAddition?.[
        selectedWorkingScheduleIndex
      ]?.exemptDates?.find((item) => item?.forDate === dateString)?.slotList
      if (!Boolean(slotList) || slotList?.length === 0) {
        if (
          dateOverrideArrayAfterAddition?.[selectedWorkingScheduleIndex]?.exemptDates?.length > 0
        ) {
          // there's a complexity here : change carefully whenever change : if the date is there in exempt dates but corresponding array is empty, it will add date again.
          dateOverrideArrayAfterAddition[selectedWorkingScheduleIndex].exemptDates = [
            ...dateOverrideArrayAfterAddition?.[selectedWorkingScheduleIndex]?.exemptDates,
            { forDate: dateString, slotList: [{ startTime: '09:00:00', endTime: '17:00:00' }] },
          ]
        } else {
          console.log('exempt dates was empty')
          dateOverrideArrayAfterAddition[selectedWorkingScheduleIndex].exemptDates = [
            { forDate: dateString, slotList: [{ startTime: '09:00:00', endTime: '17:00:00' }] },
          ]
        }
      } else {
        const lastTimeSlot = slotList?.slice(-1)
        const prevEndTime = lastTimeSlot?.[0]?.endTime
        const indexToChange = dateOverrideArrayAfterAddition?.[
          selectedWorkingScheduleIndex
        ]?.exemptDates?.findIndex((item) => item?.forDate === dateString)
        dateOverrideArrayAfterAddition?.[selectedWorkingScheduleIndex]?.exemptDates[
          indexToChange
        ]?.slotList?.push({
          startTime: moment(prevEndTime, 'HH:mm:ss')?.add(1, 'hour')?.format('HH:mm:ss'),
          endTime: moment(prevEndTime, 'HH:mm:ss')?.add(2, 'hour')?.format('HH:mm:ss'),
        })
      }

      return dateOverrideArrayAfterAddition
    })
  }

  // for slot delete button
  const handleOverrideDateSlotDelete = (dateString, indexOfSlot) => {
    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      const indexOfExemptDate = updatedSchedule?.[
        selectedWorkingScheduleIndex
      ]?.exemptDates?.findIndex((item) => item?.forDate === dateString)
      updatedSchedule?.[selectedWorkingScheduleIndex]?.exemptDates?.[
        indexOfExemptDate
      ]?.slotList?.splice(indexOfSlot, 1)
      if (
        updatedSchedule?.[selectedWorkingScheduleIndex]?.exemptDates?.[indexOfExemptDate]?.slotList
          ?.length === 0
      ) {
        updatedSchedule[selectedWorkingScheduleIndex].exemptDates[
          indexOfExemptDate
        ].available = false
      }
      return updatedSchedule
    })
  }

  // for override slot time change
  const handleOverrideChangeSlotTime = (date, slotIndex, timeType, timeValue) => {
    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      const indexOfChangedDate = updatedSchedule[
        selectedWorkingScheduleIndex
      ].exemptDates?.findIndex((item) => item?.forDate === date)
      updatedSchedule[selectedWorkingScheduleIndex].exemptDates[indexOfChangedDate].slotList[
        slotIndex
      ][timeType] = timeValue
      return updatedSchedule
    })
  }

  const handleCancelOverride = (date) => {
    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      const indexOfDate = updatedSchedule[selectedWorkingScheduleIndex].exemptDates?.findIndex(
        (item) => item?.forDate === date,
      )
      updatedSchedule?.[selectedWorkingScheduleIndex]?.exemptDates?.splice(indexOfDate, 1)

      return updatedSchedule
    })
  }

  // for override checkbox on slots
  const handleOverrideDateCheckboxChange = (event, date) => {
    const { checked } = event.target
    setSchedule((prevSchedule) => {
      const updatedSchedule = [...prevSchedule]
      const indexOfChangedDate = updatedSchedule[
        selectedWorkingScheduleIndex
      ].exemptDates?.findIndex((item) => item?.forDate === date)

      if (
        updatedSchedule[selectedWorkingScheduleIndex].exemptDates[indexOfChangedDate] &&
        indexOfChangedDate > -1
      ) {
        updatedSchedule[selectedWorkingScheduleIndex].exemptDates[indexOfChangedDate].available =
          checked
        if (checked) {
          updatedSchedule[selectedWorkingScheduleIndex].exemptDates[indexOfChangedDate].slotList = [
            { startTime: '09:00:00', endTime: '17:00:00' },
          ]
        } else {
          updatedSchedule[selectedWorkingScheduleIndex].exemptDates[indexOfChangedDate].slotList =
            []
        }
        return updatedSchedule
      }
      return prevSchedule
    })
  }

  const scheduleOfSelectedClinic = getDefaultScheduleFromSchedules(
    mentorClinicAssociationData?.find(
      (clinic) => clinic.id === schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0],
    )?.schedules,
  )

  console.log(clinicAssociationTimingWarningLocation)

  return (
    <AvailabilityPageContainer>
      <PageHeadlineComponent heading="Set your availability" />

      <PageContentOneContainer>
        <PageDescriptionText>
          Choose a schedule from below options, make a schedule default, or create a new one that
          applies to you
        </PageDescriptionText>
        {Array.isArray(mentorClinicAssociationData) && mentorClinicAssociationData?.length > 0 && (
          <PageDescriptionText style={{ textDecoration: 'underline' }}>
            <span style={{ display: 'block' }}>
              1. To accept bookings for a clinic, you must have a schedule linked to that clinic.
            </span>
            <span style={{ display: 'block' }}>
              2. Any events you wish to provide in the clinic must be part of one of the schedules
              associated with that clinic.
            </span>
            <span style={{ display: 'block' }}>
              3. The timing of such schedules should fall within the clinic&apos;s operating hours.
            </span>
          </PageDescriptionText>
        )}

        <ScheduleSelectHeading>Schedule</ScheduleSelectHeading>

        <ScheduleSelectHorizonalContainer>
          {schedule?.map((item, index) => {
            return (
              <ScheduleButton
                key={index}
                selected={selectedWorkingScheduleIndex === index}
                onClick={() => setSelectedWorkingScheduleIndex(index)}
              >
                <EventNoteIcon
                  sx={{
                    color: selectedWorkingScheduleIndex === index ? 'blue' : 'black',
                    fontSize: 20,
                  }}
                />
                <span>{item?.title}</span>
                {item?.defaultSchedule && (
                  <StarRoundedIcon sx={{ color: '#f2b724', fontSize: 20 }} />
                )}
              </ScheduleButton>
            )
          })}
          <ScheduleButton
            selected={schedule?.length === 0}
            onClick={() => setNewScheduleModalOpen(true)}
          >
            <AddCircleIcon sx={{ color: 'black', fontSize: 20 }} />
            {schedule?.length === 0 ? 'Create your first schedule' : 'New Schedule'}
          </ScheduleButton>
        </ScheduleSelectHorizonalContainer>
      </PageContentOneContainer>

      {schedule?.length !== 0 && (
        <PageMainContentContainer>
          <PageMainContentPartOne>
            <GenericDisplayFlexColumn>
              <ScheduleName main>{schedule?.[selectedWorkingScheduleIndex]?.title}</ScheduleName>
              <ScheduleName>
                {schedule?.[selectedWorkingScheduleIndex]?.defaultSchedule && (
                  <StarRoundedIcon sx={{ color: '#f2b724', fontSize: 20, marginRight: '5px' }} />
                )}
                {schedule?.[selectedWorkingScheduleIndex]?.defaultSchedule && 'default schedule'}
              </ScheduleName>
            </GenericDisplayFlexColumn>

            <SettingsIcon
              onClick={handleClickOnSettings}
              sx={{
                fontSize: 20,
                marginLeft: 'auto',
                cursor: 'pointer',
              }}
            />
            <Menu
              anchorEl={anchorForSettings}
              id="settings-menu"
              open={settingsOpen}
              onClose={handleCloseOfSettings}
              onClick={handleCloseOfSettings}
              PaperProps={{
                elevation: 0,
                sx: {
                  overflow: 'visible',
                  filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                  mt: 1.5,
                  '& .MuiAvatar-root': {
                    width: 32,
                    height: 32,
                    ml: -0.5,
                    mr: 1,
                  },
                  '&:before': {
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    top: 0,
                    right: 14,
                    width: 10,
                    height: 10,
                    bgcolor: 'background.paper',
                    transform: 'translateY(-50%) rotate(45deg)',
                    zIndex: 0,
                  },
                },
              }}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            >
              {!schedule?.[selectedWorkingScheduleIndex]?.defaultSchedule && (
                <MenuItem
                  onClick={() => {
                    handleMakeDefaultSchedule()
                    handleCloseOfSettings()
                  }}
                >
                  Make Default
                </MenuItem>
              )}
              {schedule?.length > 1 && (
                <MenuItem
                  onClick={() => {
                    handleDeleteSchedule()
                    handleCloseOfSettings()
                  }}
                >
                  Delete schedule
                </MenuItem>
              )}
            </Menu>
          </PageMainContentPartOne>

          <PageMainContentPartTwo>
            <EventAndTimeZoneContainer>
              <GenericDisplayFlexColumn>
                <ScheduleSelectHeading>Active On</ScheduleSelectHeading>
                <MultipleSelectCheckmarks
                  options={[
                    ...getEventsArrayFromEventIdsArray(
                      schedule?.[selectedWorkingScheduleIndex]?.eventIds,
                      mentorProfileData,
                    ),
                    ...getEventsNotInAnySchedule(mentorProfileData),
                  ]}
                  selected={schedule?.[selectedWorkingScheduleIndex]?.eventIds || []}
                  handleMutliSelectEventsChange={handleMutliSelectEventsChange}
                />
                <ScheduleEventsClearButton
                  style={{ color: 'red', fontWeight: 600 }}
                  onClick={handleMutliSelectClear}
                >
                  Clear All
                </ScheduleEventsClearButton>
              </GenericDisplayFlexColumn>

              <GenericDisplayFlexColumn>
                <ScheduleSelectHeading>Time Zone</ScheduleSelectHeading>
                {Array.isArray(mentorClinicAssociationData) &&
                mentorClinicAssociationData?.length > 0 &&
                schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0] &&
                scheduleOfSelectedClinic ? (
                  <div>
                    {decodeURIComponent(schedule?.[selectedWorkingScheduleIndex]?.timeZone)}
                  </div>
                ) : (
                  <StyledSelectTZCO
                    value={schedule?.[selectedWorkingScheduleIndex]?.timeZone}
                    onChange={handleTimeZoneChange}
                  >
                    {getTimeZoneOptionsWithValueAsTimezoneOffset()}
                  </StyledSelectTZCO>
                )}
              </GenericDisplayFlexColumn>

              {Array.isArray(mentorClinicAssociationData) &&
                mentorClinicAssociationData?.length > 0 && (
                  <GenericDisplayFlexColumn>
                    <ScheduleSelectHeading>Associated Clinic</ScheduleSelectHeading>
                    <StyledSelectTZCO
                      value={schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0] || ''}
                      onChange={handleClinicAssociationChange}
                    >
                      <option value="">None</option>
                      {mentorClinicAssociationData?.map((item, index) => {
                        return (
                          <option key={item?.id} value={item?.id}>
                            {item?.name}
                          </option>
                        )
                      })}
                    </StyledSelectTZCO>
                  </GenericDisplayFlexColumn>
                )}
            </EventAndTimeZoneContainer>
          </PageMainContentPartTwo>

          {Array.isArray(mentorClinicAssociationData) &&
            mentorClinicAssociationData?.length > 0 &&
            schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0] &&
            scheduleOfSelectedClinic?.weeklyHourMap && (
              <PageMainContentPartTwo>
                <div>
                  <b>
                    Clinic Hours (GMT{' '}
                    {decodeURIComponent(
                      getDefaultScheduleFromSchedules(
                        mentorClinicAssociationData?.find(
                          (clinic) =>
                            clinic.id ===
                            schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0],
                        )?.schedules,
                      )?.timeZone,
                    )}
                    ){' '}
                  </b>
                </div>
                <div>
                  {RENDERING_ORDER_OF_DAYS?.map((day, dayIndex) => {
                    return (
                      <div key={dayIndex}>
                        {scheduleOfSelectedClinic?.weeklyHourMap?.[day]?.title} :{' '}
                        {(!Boolean(scheduleOfSelectedClinic?.weeklyHourMap?.[day]?.available) ||
                          !Boolean(scheduleOfSelectedClinic?.weeklyHourMap?.[day]?.slotList)) &&
                          'CLOSED'}
                        {scheduleOfSelectedClinic?.weeklyHourMap?.[day]?.available &&
                          scheduleOfSelectedClinic?.weeklyHourMap?.[day]?.slotList?.map(
                            (slot, slotIndex) => (
                              <span key={slotIndex}>
                                ({slot?.startTime} - {slot?.endTime})
                              </span>
                            ),
                          )}
                      </div>
                    )
                  })}
                </div>
              </PageMainContentPartTwo>
            )}

          <PageMainContentPartThree>
            <UnderlineActiveButtons
              active={selectedEditMode === 'regular'}
              onClick={() => setSelectedEditMode('regular')}
            >
              Weekly hours
            </UnderlineActiveButtons>
            {/* <UnderlineActiveButtons active={selectedEditMode === "override"} onClick={() => setSelectedEditMode("override")} >Date overrides</UnderlineActiveButtons> */}
          </PageMainContentPartThree>

          {selectedEditMode === 'regular' && (
            <PageMainContentPartFour>
              {renderingOrderDays?.map((dayName, idx) => {
                const clinicError = clinicAssociationTimingWarningLocation?.[dayName]
                return (
                  <WeekItemContainer key={idx}>
                    <GenericDisplayFlex sb style={{ marginBottom: '32px' }}>
                      <GenericDisplayFlex>
                        <Checkbox
                          checked={
                            schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]
                              ?.available || false
                          }
                          onChange={(event) => {
                            handleCheckboxChange(event, dayName)
                          }}
                          size="small"
                          sx={{
                            padding: 0,
                            marginRight: 1,
                            '&.Mui-checked': {
                              color: 'blue',
                            },
                          }}
                        />
                        <div style={{ textTransform: 'uppercase' }}>
                          {
                            schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]
                              ?.title
                          }
                        </div>
                      </GenericDisplayFlex>

                      <AddIcon
                        sx={{
                          fontSize: 25,
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: '#F2F2F2',
                            borderRadius: '3px',
                          },
                        }}
                        onClick={() => handleSlotAddition(dayName)}
                      />
                    </GenericDisplayFlex>

                    {(!schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]
                      ?.slotList ||
                      schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[dayName]?.slotList
                        ?.length === 0) && (
                      <ScheduleName style={{ marginBottom: '16px' }}>Unavailable</ScheduleName>
                    )}

                    {schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[
                      dayName
                    ]?.slotList?.map((slotItem, slotIndex) => {
                      const error = warningLocation[`${dayName}-${slotIndex}`]

                      return (
                        <div key={slotIndex}>
                          <GenericDisplayFlex sb style={{ marginBottom: '16px' }}>
                            <div>
                              <select
                                value={slotItem?.startTime}
                                onChange={(e) =>
                                  handleChangeSlotTime(
                                    dayName,
                                    slotIndex,
                                    'startTime',
                                    e.target.value,
                                  )
                                }
                              >
                                {getSlotTimeOptions()}
                              </select>
                              to
                              <select
                                value={slotItem?.endTime}
                                onChange={(e) =>
                                  handleChangeSlotTime(
                                    dayName,
                                    slotIndex,
                                    'endTime',
                                    e.target.value,
                                  )
                                }
                              >
                                {getSlotTimeOptions()}
                              </select>
                            </div>

                            <DeleteIcon
                              sx={{
                                color: 'gray',
                                fontSize: 20,
                                cursor: 'pointer',
                                '&:hover': {
                                  backgroundColor: '#F2F2F2',
                                  borderRadius: '3px',
                                },
                              }}
                              onClick={() => handleSlotDelete(dayName, slotIndex)}
                            />

                            {/* {(Array.isArray(mentorClinicAssociationData) && mentorClinicAssociationData?.length > 0 && schedule?.[selectedWorkingScheduleIndex]?.scopeSchedules?.[0] && scheduleOfSelectedClinic) ?
                                                                getSlotTimeOptionsBetweenTimes(scheduleOfSelectedClinic?.weeklyHourMap?.[dayName]?.slotList) :
                                                                getSlotTimeOptions()} */}
                          </GenericDisplayFlex>

                          {Boolean(error) && (
                            <div style={{ marginBottom: '32px', color: 'red' }}>{error}</div>
                          )}
                        </div>
                      )
                    })}

                    {Boolean(clinicError) && (
                      <div style={{ marginBottom: '32px', color: 'red' }}>{clinicError}</div>
                    )}
                  </WeekItemContainer>
                )
              })}
            </PageMainContentPartFour>
          )}

          {selectedEditMode === 'override' && (
            <PageMainContentPartFour>
              <DateOverrideCalAndTimeParent>
                <OverrideCalendarContainer>
                  <Calendar
                    onChange={onChangeOverrideDate}
                    value={selectedOverrideDateValue}
                    minDate={dateToday}
                    maxDate={maxDate}
                    minDetail="decade"
                    showNeighboringMonth={false}
                    onActiveStartDateChange={({ action, activeStartDate, value, view }) =>
                      handleOverrideMonthChange(action, activeStartDate, value, view)
                    }
                  />
                </OverrideCalendarContainer>
                {selectedOverrideDateValue && (
                  <GenericDisplayFlexColumn style={{ gap: '10px' }}>
                    <div>
                      <b>
                        New Schedule for{' '}
                        {moment(selectedOverrideDateValue)?.format('ddd, MMM D, YYYY')}
                      </b>
                    </div>
                    {schedule?.[selectedWorkingScheduleIndex]?.exemptDates?.find(
                      (item) =>
                        item?.forDate ===
                        moment(selectedOverrideDateValue)
                          ?.startOf('day')
                          ?.format('YYYY-MM-DD HH:mm:ss'),
                    ) ? (
                      <div
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() =>
                          handleCancelOverride(
                            moment(selectedOverrideDateValue)
                              ?.startOf('day')
                              ?.format('YYYY-MM-DD HH:mm:ss'),
                          )
                        }
                      >
                        Overrides Active. Cancel?
                      </div>
                    ) : (
                      <div
                        style={{ cursor: 'pointer', textDecoration: 'underline' }}
                        onClick={() =>
                          handleOverrideDateSlotAddition(
                            moment(selectedOverrideDateValue)
                              ?.startOf('day')
                              ?.format('YYYY-MM-DD HH:mm:ss'),
                          )
                        }
                      >
                        No Overrides. Create?
                      </div>
                    )}
                    {schedule?.[selectedWorkingScheduleIndex]?.exemptDates?.find(
                      (item) =>
                        item?.forDate ===
                        moment(selectedOverrideDateValue)
                          ?.startOf('day')
                          ?.format('YYYY-MM-DD HH:mm:ss'),
                    ) && (
                      <div>
                        Available :
                        <Checkbox
                          checked={
                            schedule?.[selectedWorkingScheduleIndex]?.exemptDates?.find(
                              (item) =>
                                item?.forDate ===
                                moment(selectedOverrideDateValue)
                                  ?.startOf('day')
                                  ?.format('YYYY-MM-DD HH:mm:ss'),
                            )?.available || false
                          }
                          onChange={(event) => {
                            handleOverrideDateCheckboxChange(
                              event,
                              moment(selectedOverrideDateValue)
                                ?.startOf('day')
                                ?.format('YYYY-MM-DD HH:mm:ss'),
                            )
                          }}
                          size="small"
                          sx={{
                            padding: 0,
                            marginRight: 1,
                            '&.Mui-checked': {
                              color: 'blue',
                            },
                          }}
                        />
                      </div>
                    )}
                    {schedule?.[selectedWorkingScheduleIndex]?.exemptDates?.find(
                      (item) =>
                        item?.forDate ===
                        moment(selectedOverrideDateValue)
                          ?.startOf('day')
                          ?.format('YYYY-MM-DD HH:mm:ss'),
                    ) && (
                      <AddIcon
                        sx={{
                          fontSize: 25,
                          cursor: 'pointer',
                          '&:hover': {
                            backgroundColor: '#F2F2F2',
                            borderRadius: '3px',
                          },
                        }}
                        onClick={() =>
                          handleOverrideDateSlotAddition(
                            moment(selectedOverrideDateValue)
                              ?.startOf('day')
                              ?.format('YYYY-MM-DD HH:mm:ss'),
                          )
                        }
                      />
                    )}
                    {schedule?.[selectedWorkingScheduleIndex]?.exemptDates
                      ?.find(
                        (item) =>
                          item?.forDate ===
                          moment(selectedOverrideDateValue)
                            ?.startOf('day')
                            ?.format('YYYY-MM-DD HH:mm:ss'),
                      )
                      ?.slotList?.map((slotItem, slotItemIndex) => {
                        return (
                          <div key={slotItemIndex}>
                            <select
                              value={slotItem?.startTime}
                              onChange={(e) =>
                                handleOverrideChangeSlotTime(
                                  moment(selectedOverrideDateValue)
                                    ?.startOf('day')
                                    ?.format('YYYY-MM-DD HH:mm:ss'),
                                  slotItemIndex,
                                  'startTime',
                                  e.target.value,
                                )
                              }
                            >
                              {getSlotTimeOptions()}
                            </select>
                            to
                            <select
                              value={slotItem?.endTime}
                              onChange={(e) =>
                                handleOverrideChangeSlotTime(
                                  moment(selectedOverrideDateValue)
                                    ?.startOf('day')
                                    ?.format('YYYY-MM-DD HH:mm:ss'),
                                  slotItemIndex,
                                  'endTime',
                                  e.target.value,
                                )
                              }
                            >
                              {getSlotTimeOptions()}
                            </select>
                            <DeleteIcon
                              sx={{
                                color: 'gray',
                                fontSize: 20,
                                cursor: 'pointer',
                                '&:hover': {
                                  backgroundColor: '#F2F2F2',
                                  borderRadius: '3px',
                                },
                              }}
                              onClick={() =>
                                handleOverrideDateSlotDelete(
                                  moment(selectedOverrideDateValue)
                                    ?.startOf('day')
                                    ?.format('YYYY-MM-DD HH:mm:ss'),
                                  slotItemIndex,
                                )
                              }
                            />
                          </div>
                        )
                      })}
                    <hr />
                    <div>
                      <b>
                        Your default schedule for{' '}
                        {moment(selectedOverrideDateValue)?.startOf('day')?.format('dddd')} :
                      </b>
                    </div>
                    <div>
                      Available :{' '}
                      {schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[
                        moment(selectedOverrideDateValue)
                          ?.startOf('day')
                          ?.format('dddd')
                          ?.toLowerCase()
                      ]?.available
                        ? 'Yes'
                        : 'No'}
                    </div>
                    {schedule?.[selectedWorkingScheduleIndex]?.weeklyHourMap?.[
                      moment(selectedOverrideDateValue)
                        ?.startOf('day')
                        ?.format('dddd')
                        ?.toLowerCase()
                    ]?.slotList?.map((slotItem, slotIndex) => {
                      return (
                        <div key={slotIndex}>
                          {moment(slotItem?.startTime, 'HH:mm:ss')?.format('h:mmA')} to{' '}
                          {moment(slotItem?.endTime, 'HH:mm:ss')?.format('h:mmA')}
                        </div>
                      )
                    })}
                  </GenericDisplayFlexColumn>
                )}
              </DateOverrideCalAndTimeParent>
            </PageMainContentPartFour>
          )}
        </PageMainContentContainer>
      )}

      {/* for adding new schedule */}
      <GenericMentorPortalModalComponent
        newScheduleModalOpen={newScheduleModalOpen}
        setNewScheduleModalOpen={setNewScheduleModalOpen}
        isAtBottom
      >
        <NewSchedulePageComponent
          setNewScheduleModalOpen={setNewScheduleModalOpen}
          handleScheduleCreation={handleScheduleCreation}
          windowWidth={width}
        />
      </GenericMentorPortalModalComponent>
    </AvailabilityPageContainer>
  )
}

function giveErrorIfOutsideClinicHours(
  schedule,
  selectedWorkingScheduleIndex,
  scheduleOfSelectedClinic,
  clinicAssociationTimingWarningLocation,
) {
  const scheduleNow = schedule?.[selectedWorkingScheduleIndex]
  const desiredSchedule = scheduleOfSelectedClinic
  let toReturn = { ...clinicAssociationTimingWarningLocation }

  RENDERING_ORDER_OF_DAYS?.forEach((dayName) => {
    toReturn = { ...toReturn, [dayName]: undefined }
  })

  //   RENDERING_ORDER_OF_DAYS?.forEach((dayName) => {
  //     if (
  //       scheduleNow?.weeklyHourMap?.[dayName]?.available &&
  //       !desiredSchedule?.weeklyHourMap?.[dayName]?.available
  //     ) {
  //       toReturn = { ...toReturn, [dayName]: 'Timings must be inside clinic hours to save' }
  //     } else {
  //       const slotAllowedArray = []
  //       scheduleNow?.weeklyHourMap?.[dayName]?.slotList?.forEach((scheduleNowSlot) => {
  //         // if this slot is inside or equal to any of the slots of clinic, then put true in array, doing this for all slots in slotList, expecting all slots to be allowed and array to be [true, true...]
  //         let checkedSlotInsideAnyDesiredSchedule = false
  //         desiredSchedule?.weeklyHourMap?.[dayName]?.slotList?.forEach((desiredScheduleSlot) => {
  //           if (
  //             scheduleNowSlot?.startTime >= desiredScheduleSlot?.startTime &&
  //             scheduleNowSlot?.endTime <= desiredScheduleSlot?.endTime
  //           ) {
  //             if (!checkedSlotInsideAnyDesiredSchedule) {
  //               checkedSlotInsideAnyDesiredSchedule = true
  //             }
  //           }
  //         })
  //         slotAllowedArray.push(checkedSlotInsideAnyDesiredSchedule)
  //       })

  //       if (slotAllowedArray?.some((item) => !Boolean(item))) {
  //         toReturn = { ...toReturn, [dayName]: 'Timings must be inside clinic hours to save' }
  //       } else {
  //         toReturn = { ...toReturn, [dayName]: undefined }
  //       }
  //     }
  //   })
  return toReturn
}

//// handling clinic related things :
// mapping user journey :
// 1. ✅ when toggle is changed, we change schedule to be the same as clinic default schedule(weekly hour map and timezone). and switch to a default schedule if association removed.(because of autosave). autosave must be removed.
// 2. ✅ we disable changing of time zone here
// 3. SKIPPING : we only allow clinic related events to be visible there. and other schedules should not see clinic events
// 4. only options available in time dropdown are from schedule of clinic so enforcing a time schedule here
// 5. ✅ if some one tries to bypass this, saving is not done
